import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0090',
    ecrans: ['00-2']
});
